import { useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import {
  useLoadColumbusPlanner as useGeneratedLoadColumbusPlanner,
  useSaveColumbusTimeLine as useGeneratedSaveColumbusTimeLine,
  useSaveColumbusPlannerSettings as useGeneratedSaveColumbusPlannerSettings,
  getLoadColumbusPlannerQueryKey,
} from '@/api/generated/columbus-planner/columbus-planner';

const LOAD_COLUMBUS_PLANNER_STALE_MS = 5000;

export function useLoadColumbusPlanner(productId: number, termsSerialId: number) {
  return useGeneratedLoadColumbusPlanner(productId, termsSerialId, {
    query: { staleTime: LOAD_COLUMBUS_PLANNER_STALE_MS },
  });
}

export function useSaveColumbusTimeLine() {
  const queryClient = useQueryClient();
  return useGeneratedSaveColumbusTimeLine({
    mutation: {
      onSuccess: (_, { data }) => {
        void queryClient.invalidateQueries({
          queryKey: getLoadColumbusPlannerQueryKey(data.productId, data.termsSerialId),
          refetchType: 'none',
        });
      },
    },
  });
}

export function useSaveColumbusPlannerSettings(productId: number, termsSerialId: number) {
  const queryClient = useQueryClient();
  const paramsRef = useRef({ productId, termsSerialId });
  paramsRef.current = { productId, termsSerialId };
  return useGeneratedSaveColumbusPlannerSettings({
    mutation: {
      onSuccess: () => {
        void queryClient.invalidateQueries({
          queryKey: getLoadColumbusPlannerQueryKey(
            paramsRef.current.productId,
            paramsRef.current.termsSerialId
          ),
          refetchType: 'none',
        });
      },
    },
  });
}
